export const GET_NOTIFICATIONS_QUERY = `
  query GetNotificationsForNotificationCenter($options: NotificationsInput!) {
    notifications(options: $options) {
      unreadCount
      items {
        action {
          leadsToUserActionFulfillment
          name
          target
          targetType
          text
          __typename
        }
        body
        campaignId
        campaignName
        createdAt
        id
        imageDetails {
          altText
          sourceUrl
          __typename
        }
        isDismissed
        isRead
        pinDetails {
          isPinned
          updatedAt
          __typename
        }
        slug
        templateId
        templateName
        __typename
      }
      __typename
    }
  }
`;
